export function createApiError(response) {
  const data = response?.data ?? {}
  const status = response?.status ?? 500

  const error = new Error(
    typeof data.message === 'string' ? data.message : 'Request failed',
  )
  error.name = 'ApiError'
  error.code =
    typeof data.error === 'string'
      ? data.error
      : status === 404
        ? 'not_found'
        : status >= 500
          ? 'server_error'
          : 'unknown_error'
  error.details = Array.isArray(data.details)
    ? data.details
    : data.details && typeof data.details === 'object'
      ? data.details
      : []
  error.status = status
  error.response = response

  return error
}

export function parseApiResponse(response) {
  const data = response?.data

  if (data?.result === false) {
    throw createApiError(response)
  }

  return data
}
